import { EParkingType, FOfferType } from '../../../../../JsonQuery';
import { IParking } from './types';

const PARKING_TYPES: IParking[] = [
  { label: 'Неважно', value: null },
  { label: 'Наземная', value: EParkingType.Ground },
  { label: 'Многоуровневая', value: EParkingType.Multilevel },
  { label: 'Подземная', value: EParkingType.Underground },
  { label: 'На крыше', value: EParkingType.Rooftop },
];

export function getParkingTypes(offerType: FOfferType) {
  if (offerType === FOfferType.Garage) {
    return PARKING_TYPES.filter(({ value }) => value !== EParkingType.Rooftop);
  }

  return PARKING_TYPES;
}
